export const ProductTypeEnum = {
  EXPERIENCE: 'experience',
  HOTEL: 'hotel',
  ALL: 'all',
};

export const ProgramAccommodationTypeEnum = {
  NIGHT_TRANSFER: 'nightTransfer',
  NO_ACCOMMODATION: 'noAccomodation', // The typo is intentional to match the API
  FREE_ACCOMMODATION: 'freeAccomodation', // The typo is intentional to match the API
  HOTEL: 'hotel',
  BOOKED_ON_MY_OWN: 'bookedOnMyOwn',
};

export const ExperienceTypeEnum = {
  PROGRAM: 'Program',
  TRANSFER: 'Transfer',
  ACTIVITY: 'Activity',
  ALL_EXPERIENCE_TYPES: 'AllExperienceTypes',
  EXTRA: 'Extra',
};

export const ExperiencePricingTypeEnum = {
  FIT: 'fit',
  SIC: 'sic',
  SERIES: 'series',
};

export const ExperienceStateEnum = {
  AVAILABLE: 'available',
  IN_PROGRESS: 'in_progress',
  STAND_BY: 'stand_by',
};

export const ExperiencePeriodStateEnum = {
  ON_REQUEST: 'on_request',
  STOP_SALE: 'stop_sale',
  FREE_SALE: 'free_sale',
  PRE_CONFIRMED: 'pre_confirmed',
};

export const ExtraScopeEnum = {
  GLOBAL: 'global',
  DAY: 'day',
};

// Where a selected extra comes from. The basket is refreshed in place and
// writes its own result back, so the entries synthesized from a program's
// included experiences have to be told apart from the options the user picked:
// without it, a refresh cannot know which flags it wrote itself last pass.
export const ExtraSourceEnum = {
  USER: 'user',
  PROGRAM_INCLUDED: 'programIncluded',
};

export const ExtraRequirementEnum = {
  REQUIRED: 'required',
  SUGGESTED: 'suggested',
};

export const OrderDirectionEnum = {
  DESC: 'desc',
  ASC: 'asc',
};

export const OrderColumnEnum = {
  UPDATED_AT: 'updated_at',
  CREATED_AT: 'created_at',
  STATE: 'state',
  TITLE: 'title',
};

export const ApiPollingStateEnum = {
  IN_PROGRESS: 'inProgress',
  FINISHED: 'finished',
};

export const RoleEnum = {
  KOOB_ADMIN: 'koob_admin',
  DMC_ADMIN: 'dmc_admin',
  DMC_USER: 'dmc_user',
  TO_ADMIN: 'to_admin',
  TO_USER: 'to_user',
  SUPER_ADMIN: 'super_admin',
};

export const AllotmentDayStateEnum = {
  ON_REQUEST: 'on_request',
  STOP_SALE: 'stop_sale',
  FREE_SALE: 'free_sale',
  ALLOTMENT: 'allotment',
};

export const ApiKeyCustomIntegration = {
  NEZASA: 'nezasa',
  STAAH: 'staah',
  KOEDIA: 'koedia',
  MONITORING: 'monitoring',
};

export const ChannelManagerEnum = {
  KOOB: 'koob',
  KOEDIA: 'koedia',
  RAKUTEN: 'rakuten',
  STAAH: 'staah',
  TL_LINCOLN: 'tl_lincoln',
};

export const HotelStateEnum = {
  AVAILABLE: 'available',
  IN_PROGRESS: 'inProgress',
  STAND_BY: 'standBy',
  ARCHIVED: 'archived',
};

export const HotelContractStatusEnum = {
  PUBLISHED: 'published',
  PUBLISHING: 'publishing',
  DRAFT: 'draft',
};

export const ExperienceFilterSortEnum = {
  PRICE_ASC: 'price.asc',
  PRICE_DESC: 'price.desc',
  PROMOTIONS_DESC: 'promotions.desc',
};

export const TravelerKindEnum = {
  ADULT: 'adult',
  CHILD: 'child',
  INFANT: 'infant',
};

export const ContractStateFilterEnum = {
  AVAILABLE: 'available',
  EXPIRED: 'expired',
};

export const OrganizationScopeEnum = {
  TO: 'to',
  DMC: 'dmc',
};

export const ProductKindEnum = {
  HOTELS: 'hotels',
  EXPERIENCES: 'experiences',
  TRIP: 'trips',
  ADDITIONAL_SERVICES: 'additional-services',
};

export const LocationFiltersKindEnum = {
  HOTELS: 'hotels',
  REGIONS: 'regions',
  CITIES: 'cities',
  COUNTRIES: 'countries',
};

export const LocationFilterKindEnum = {
  HOTEL: 'hotel',
  REGION: 'region',
  CITY: 'city',
  COUNTRY: 'country',
};

export const PromotionKindEnum = {
  BASIC_DEAL: 'basic_deal',
  EARLY_BOOKER: 'early_booker',
  LAST_MINUTE: 'last_minute',
  // The single spelling: what the promotion form submits, what the API persists
  // in promotions.kind, and what every availability gate filters on.
  STAY_FLEXIBILITY: 'stay_flexibility',
};

export const BenefitsKindEnum = {
  AMENITY: 'Benefits::Amenity',
  AMOUNT: 'Benefits::Amount',
  FREE_NIGHT: 'Benefits::FreeNight',
  PERCENT: 'Benefits::Percent',
  UPGRADE_ROOM: 'Benefits::UpgradeRoom',
  SUPPLEMENT: 'Benefits::Supplement',
  SUPPLEMENT_PERCENT: 'Benefits::SupplementPercent',
};

export const AdminBookingStateEnum = {
  CONFIRMED: 'confirmed',
  PRE_CONFIRMED: 'pre_confirmed',
  PENDING: 'pending',
  PENDING_SOURCE: 'pending_source',
  DRAFT: 'draft',
  CANCELLED: 'canceled',
  REFUSED: 'refused',
  SENT: 'sent',
  REPLACED: 'replaced',
  FAILED: 'failed',
};

export const FolderStatusEnum = {
  NEW: 'new',
  DRAFT: 'draft',
  CONFIRMING: 'confirming',
  CONFIRMED: 'confirmed',
  ON_SPOT: 'on_spot',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  // KD-3842: the only stored status; every other one is derived from bookings.
  ARCHIVED: 'archived',
};

// Mirrors the API's TripConversation StatusValue: a conversation reaches
// CLOSED for good, and no message can be added to it any more.
export const TripConversationStatusEnum = {
  NEW: 'new',
  PENDING_DMC: 'pending_dmc',
  PENDING_TO: 'pending_to',
  CLOSED: 'closed',
};

export const AttachmentKindEnum = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

export const NotificationChannelEnum = {
  MAIL: 'mail',
  DATABASE: 'database',
};

export const LocationOrderColumnEnum = {
  CITY_TITLE: 'title',
  CODE: 'code',
  REGION_TITLE: 'region_title',
  COUNTRY_TITLE: 'country_title',
};

export const SupplierEnum = {
  KOOB: 'Koob',
  KOEDIA: 'Koedia',
  RAKUTEN: 'Rakuten',
  STAAH: 'STAAH',
  TL_LINCOLN: 'TL_LINCOLN',
};

export const PromotionTypeEnum = {
  AMOUNT: 'amount',
  PERCENT: 'percent',
  SUPPLEMENT: 'supplement',
  SUPPLEMENT_PERCENT: 'supplement_percent',
};

export const StayFlexibleCodeEnum = {
  EARLY_CHECK_IN: 'early_check_in',
  LATE_CHECK_OUT: 'late_check_out',
};

export const RequestAccessTypeEnum = {
  MARKETPLACE: 'marketPlace',
  TRIP_DESIGNER: 'tripDesigner',
};

export const RequestAccessStateEnum = {
  PENDING: 'pending',
  VALIDATED: 'validated',
  REFUSED: 'refused',
  NOT_REQUESTED: 'not_requested',
};

export const JobStatusEnum = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const JobQueueEnum = {
  DEFAULT: 'default',
  CONTRACT_PUBLISH: 'contract_publish',
};

export const ExperienceCurrencyMismatch = 'MISMATCH';

export const CurrencyStateEnum = {
  MISMATCH: 'mismatch',
};

export const PartnershipStatusEnum = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  PENDING: 'pending',
};

export const ExportDayHotelRoomTagEnum = {
  REFUNDABLE: 'refundable',
  NO_REFUNDABLE: 'no_refundable',
  ROOM_REFUNDABLE: 'room_refundable',
  ROOM_NON_REFUNDABLE: 'room_non_refundable',
};

export const SustainableLevelEnum = {
  ZERO: 1,
  LOW: 2,
  MEDIUM: 3,
  STRONG: 4,
};

export const ConnectionTypeEnum = {
  HOTELS: 'hotels',
  EXPERIENCES: 'experiences',
  TEMPLATES: 'templates',
};

export const TravelDiarySettingsEnum = {
  SECTION: 'section',
  SUBSECTION: 'subsection',
  FIELD: 'field',
};

export const BookingSourceAbbreviationEnum = {
  TRIP_DESIGNER: 'TD',
  MARKETPLACE: 'MKP',
};

export const ClientFolderFilterEnum = {
  BOOKING: 'booking',
  TRAVEL: 'travel',
  CREATION: 'creation',
};

export const AdjustmentKindEnum = {
  DISCOUNT: 'discount',
  SUPPLEMENT: 'supplement',
};

export const AdjustmentAmountTypeEnum = {
  FIXED: 'fixed',
  PERCENTAGE: 'percentage',
};

export const AdjustmentApplyToEnum = {
  ENTIRE_TRIP: 'entire_trip',
  ENTIRE_BOOKING: 'entire_booking',
  SPECIFIC_ITEMS: 'specific_items',
};

export const AdjustmentScopeEnum = {
  PRODUCT: 'product',
  ENTIRE_BOOKING: 'entire_booking',
  ENTIRE_TRIP: 'entire_trip',
};

export const AdjustmentUnitEnum = {
  PERCENTAGE: '%',
  AMOUNT: 'amount',
};

// Mirrors the API's BookingAdjustmentImpactEnum: which side of the price an
// adjustment moves. The purchase price and the margin on top of it are only
// chosen product by product ("Specific products"); an entire booking or trip
// moves the selling price.
export const AdjustmentImpactEnum = {
  MARGIN: 'margin',
  PURCHASE_PRICE: 'purchase_price',
  SELLING_PRICE: 'selling_price',
};

export const BookingKindEnum = {
  DMC: 'DMC',
  KOEDIA: 'KOEDIA',
  RAKUTEN: 'RAKUTEN',
  STAAH: 'STAAH',
};

export const BookingTypeEnum = {
  TRIP: 'trip',
  BOOKING: 'booking',
};

export const PromotionStateEnum = {
  DRAFT: 'draft',
  OPERATIONAL: 'operational',
  ARCHIVED: 'archived',
};

// Status badges of the promotions list (KD-3666): the lifecycle stage for
// drafts / archived offers, the date-based status for operational ones,
// plus the completeness flag shown next to Draft.
export const PromotionStatusEnum = {
  ACTIVE: 'active',
  PLANNED: 'planned',
  EXPIRED: 'expired',
  DRAFT: 'draft',
  ARCHIVED: 'archived',
  INCOMPLETE: 'incomplete',
};

export const ExperienceCompatibilityTypeEnum = {
  FOR: 'FOR',
  TO: 'TO',
};

export const TravelDiaryPriceDisplayLevelEnum = {
  TOTAL: 'total',
  CATEGORY: 'category',
  ITEMIZED: 'itemized',
};

export const ServiceApplicationDateKindEnum = {
  SINGLE: 'single',
  RANGE: 'range',
};

export const PrivateModeKindEnum = {
  DMC: 'dmc',
  HOTEL_KEEPER: 'hotelKeeper',
};

// Not an enum, but both apps' hotel-availability catalog paged on this exact
// value before US-025; kept here so neither app depends on the other's
// constants module.
export const PER_PAGE_FOR_HOTELS_AVAILABILITY = 48;
